import React, { useEffect, useState } from "react";
import api, { BRAND_COLORS, formatApiError } from "@/lib/api";
import { PageHead, Loading } from "@/components/common";
import { toast } from "sonner";

export default function Brands() {
  const [brands, setBrands] = useState(null);
  const load = () => api.get("/brands").then((r) => setBrands(r.data));
  useEffect(() => { load(); }, []);

  const save = async (b, field, value) => {
    try {
      await api.patch(`/brands/${b.id}`, { [field]: value });
      toast.success(`${b.name} updated`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!brands) return <Loading />;
  return (
    <div>
      <PageHead overline="Brand Master" title="Brands" desc="Program client label: SUGAR Cosmetics. Three workbook brands seeded. Colors & welcome content are editable before launch." />
      <div className="grid md:grid-cols-3 gap-5">
        {brands.map((b) => (
          <div key={b.id} data-testid={`brand-card-${b.id}`} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <div className="h-24 flex items-end p-4" style={{ background: `linear-gradient(135deg, ${b.accent}dd, ${b.accent}99)` }}>
              <div className="text-white">
                <div className="text-lg font-bold font-head">{b.name}</div>
                <div className="text-xs opacity-90">{b.tagline}</div>
              </div>
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Code</span><span className="font-mono font-semibold">{b.code}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Active</span>
                <button data-testid={`brand-toggle-${b.id}`} onClick={() => save(b, "active", !b.active)}
                  className={`px-2.5 py-1 rounded-full text-xs font-semibold ${b.active ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                  {b.active ? "Active" : "Inactive"}
                </button>
              </div>
              <div>
                <label className="text-xs text-slate-500">Accent color</label>
                <input data-testid={`brand-accent-${b.id}`} type="color" defaultValue={b.accent} onBlur={(e) => save(b, "accent", e.target.value)}
                  className="w-full h-9 rounded-lg border border-slate-200 mt-1 cursor-pointer" />
              </div>
              <div>
                <label className="text-xs text-slate-500">Welcome message</label>
                <textarea defaultValue={b.welcome} onBlur={(e) => save(b, "welcome", e.target.value)} rows={2}
                  className="w-full mt-1 text-sm px-3 py-2 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-violet-200" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
